import { UserInputPage } from 'src/actuators/user-input/UserInputPage.tsx';
import { Suspense, useContext, useMemo } from 'react';
import {
    ActuatorsAppUserInputPageData, ActuatorsAppUserInputPageVariables,
    getUserInputPageConfig,
} from 'src/actuators/user-input/userInputPageMapping.ts';
import { useFilterLogic } from 'src/modules/common/hooks/useFilterLogic.ts';
import { getFilterComposed } from 'src/modules/common/hooks/getFilterComposed.ts';
import { Query } from 'src/modules/common/components/Query/Query.tsx';
import { ConfigContext } from 'src/configContext.ts';
import { SkeletonMainLayout } from 'src/modules/common/skeletons/SkeletonMainLayout/SkeletonMainLayout.tsx';

export const PrefetchUserInput = () => {
    const { userSettings, mandatoryFilterConfig } = useContext(ConfigContext);
    const pageConfig = useMemo(() => getUserInputPageConfig(userSettings.currentRegion), [userSettings]);
    if (pageConfig === null) {
        throw new Error('No Page Config!');
    }

    const [, filter] = useFilterLogic(pageConfig.filterConfig);

    const [mainFilter] = getFilterComposed([
        ...pageConfig.filterConfig,
    ], filter, mandatoryFilterConfig, userSettings.currentLocale);
    return (
        <Suspense fallback={<SkeletonMainLayout/>}>
            <Query<ActuatorsAppUserInputPageData, ActuatorsAppUserInputPageVariables>
                query={pageConfig.query}
                variables={{
                    variables: {
                        filter: mainFilter,
                        locale: userSettings.currentLocale,
                        shoppingCenter: userSettings.shoppingCenter ?? '',
                    },
                }}
            >
                {({ data }) => {
                    if (data === undefined) {
                        return (<SkeletonMainLayout/>);
                    }
                    return (<UserInputPage data={data}/>);
                }}
            </Query>
        </Suspense>
    );
};
